// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jWUeT","col":"styles_col__22gJB","actions":"styles_actions__2JJHg","conflict":"styles_conflict__1atLK"};